// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","883":"component---src-pages-404-js"}[chunkId] + "-" + {"230":"b6303541169af5393806","883":"67928ffb89d93e22bd4f"}[chunkId] + ".js";
};